import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-6">
              Czy Kakobuy jest bezpieczny?
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-6">
              Bezpieczeństwo zakupów online jest najważniejsze. Dlatego każda decyzja zakupowa
              powinna uwzględniać kilka kluczowych aspektów, które pomogą Ci uniknąć
              nieprzyjemnych niespodzianek i cieszyć się udanymi zakupami.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {[
                { icon: 'ri-user-search-line', text: 'Sprawdzenie sprzedawcy' },
                { icon: 'ri-zoom-in-line', text: 'Analiza zdjęć QC' },
                { icon: 'ri-scales-3-line', text: 'Porównanie cen' },
                { icon: 'ri-lock-line', text: 'Ochrona danych' },
              ].map((item) => (
                <div
                  key={item.text}
                  className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={item.icon}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-700">{item.text}</span>
                </div>
              ))}
            </div>
            <Link
              to="/artykul/kakobuy-spreadsheet-polska-poradnik"
              className="inline-flex items-center gap-2 text-sm font-label font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Przeczytaj pełny poradnik bezpieczeństwa
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="w-full max-w-md aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Secure%20modern%20workspace%20with%20laptop%20showing%20protective%20shield%20icon%20and%20shopping%20bags%20beside%20it%2C%20warm%20cream%20beige%20tones%2C%20soft%20natural%20daylight%2C%20trust%20and%20security%20atmosphere%2C%20editorial%20product%20photography%2C%20clean%20Scandinavian%20aesthetic%2C%20gentle%20shadows%2C%20high%20detail%2C%20organic%20textures%2C%20professional%20business%20environment%2C%20calming%20and%20reassuring%20mood&width=800&height=600&seq=kakobuy-safety-v3-2026&orientation=landscape"
                alt="Bezpieczeństwo Kakobuy - bezpieczne zakupy online"
                title="Kakobuy Spreadsheet Polska - bezpieczeństwo zakupów"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}